import { render } from "./ActionSection.vue?vue&type=template&id=7c4d9dfc"
import script from "./ActionSection.vue?vue&type=script&lang=js"
export * from "./ActionSection.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/newsletter.norden.org/releases/74710130/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__